import React from "react";
import { Navigate } from "react-router-dom";
import { getTeacherAuth } from "./teacherApi";

const TeacherProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const auth = getTeacherAuth();

  if (!auth?.isAuthenticated || !auth?.token) {
    return <Navigate to="/LMS/login" replace />;
  }

  if (String(auth.role || "").toLowerCase() !== "teacher") {
    return <Navigate to="/learn-with-us" replace />;
  }

  return <>{children}</>;
};

export default TeacherProtectedRoute;
